import { gnarSpec } from '@lib/tracking/gnar'
import { WallGuardWallResult } from './types'

export const wallGuardTracking = (wallGuard: WallGuardWallResult, pageId: string, slug: string) => {
  switch (wallGuard.wallToTrigger) {
    case 'textLimit':
      gnarSpec.toolTextLimitWallShow(pageId, slug)
      break
    case 'goTemplates':
    case 'usage':
      gnarSpec.toolUsageWallShow(pageId, slug)
      break
    default: {
      console.warn(`Unknown wall type: ${wallGuard.wallToTrigger}`)
    }
  }
}
